export default{

    title: 'Profmos',
    homeRoute: 'overview-period',
    basePath: '',

    pagingLimit: 20
};
